import React from 'react';
import { Icon } from '@fluentui/react';

class PageNavi extends React.Component
{
    constructor(props)
    {
        super(props)
        this.state = {
            page: this.props.pageNum ? this.props.pageNum : 1
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.pageNum !== this.props.pageNum) {
            this.setState({
                page: this.props.pageNum
            });
        }
    }

    setNextPage()
    {
        if(this.lastPageReached()) return;
        let page = this.state.page + 1;
        this.setState({page: page });
        this.props.pageNumPart(page);
    }
    
    setPreviousPage()
    {
        let page = this.state.page - 1;
        if(page > 0) {
            this.setState({page: page})
            this.props.pageNumPart(page);
        }
    }

    lastPageReached()
    {
        return this.rightBorder() === this.props.totalResults
    }

    leftBorder()
    {
        if(this.props.totalResults === 0) return 0;
      let b = (Number(this.state.page) - 1) * Number(this.props.resultsOnPage) + 1;
      return b;
    }

    rightBorder()
    {

        let b = Number(this.state.page) * Number(this.props.resultsOnPage);
        if(b > this.props.totalResults) return this.props.totalResults;
        return b;
    }

    render() {
        const leftN = this.leftBorder();
        const rightN = this.rightBorder();
        return(
            <div style={{textAlign: 'center'}}>
                <button className="page-button-left"  onClick={this.setPreviousPage.bind(this)}> <Icon iconName="ChevronLeft"  /></button>
                <div className='center-page-nav'>
                    <div>{leftN} - {rightN}{this.props.showTotalResults ? ` of ${this.props.totalResults}` : ''}</div>
                </div>
                <button className="page-button-right"  onClick={this.setNextPage.bind(this)}> <Icon iconName="ChevronRight"  /></button>
            </div>
        );
    }
}
export default PageNavi


// WEBPACK FOOTER //
// ./src/components/Administration/PageNavi.js